import { FC, useEffect } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  TOOTH_ATTACHMENT,
  TOOTH_ATTACHMENT_OPTIONS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import DentitionTypeWithToothCharts from './DentitionTypeWithToothCharts/DentitionTypeWithToothCharts';
import { FormLabel } from './FormLabel/FormLabel';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
interface Props {
  fieldName: string;
  title: string;
  animateLabel: string;
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
  isToothChartRestricted?: boolean;
}
const ToothAttachment: FC<Props> = ({
  fieldName,
  title,
  isDisabled,
  animateLabel,
  isUpperDisabled,
  isLowerDisabled,
  isToothChartRestricted
}) => {
  const {
    watch,
    trigger,
    formState: { errors, isSubmitted }
  } = useFormContext();
  const watchedFields = [
    `${fieldName}.attachment`,
    `${fieldName}.dentitionSelection`,
    `${fieldName}.toothChart`,
    `${fieldName}.primaryToothChart`
  ];
  const [
    watchAttachmentSelection,
    dentitionSelection,
    toothChart,
    primaryToothChart
  ] = watch(watchedFields);
  const restrictedAdultToothChartValue = watch(
    fieldName.replace(/\.toothAttachment$/, '.toothInformation') + '.toothChart'
  );
  const restrictedPrimaryToothChartValue = watch(
    fieldName.replace(/\.toothAttachment$/, '.toothInformation') +
      '.primaryToothChart'
  );
  const fieldError = _.get(errors, `${fieldName}`);

  useEffect(() => {
    if (isSubmitted) trigger(watchedFields);
  }, [
    watchAttachmentSelection,
    dentitionSelection,
    toothChart,
    primaryToothChart,
    isSubmitted,
    trigger
  ]);

  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate(title)}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={animateLabel}
      />
      <div>
        <RhfRadioGroup
          inputProps={{ disabled: isDisabled }}
          options={TOOTH_ATTACHMENT_OPTIONS}
          name={`${fieldName}.attachment`}
          className='flex flex-row space-x-16'
          radioClassName='border-RADIO_BORDER'
          radioItemFont='md:text-17px text-sm '
        />
      </div>

      {watchAttachmentSelection === TOOTH_ATTACHMENT.NO_ATTACHMENT && (
        <div className='my-6 ml-5'>
          <DentitionTypeWithToothCharts
            dentitionSelectionName={`${fieldName}.dentitionSelection`}
            adultChartName={`${fieldName}.toothChart`}
            primaryChartName={`${fieldName}.primaryToothChart`}
            disabled={isDisabled}
            isUpperDisabled={isUpperDisabled}
            isLowerDisabled={isLowerDisabled}
            isToothChartRestricted={isToothChartRestricted}
            restrictedAdultToothChartValue={restrictedAdultToothChartValue}
            restrictedPrimaryToothChartValue={restrictedPrimaryToothChartValue}
          />
        </div>
      )}
    </div>
  );
};
export default ToothAttachment;
